module.exports = __webpack_public_path__ + "img/logo.45b1f2c7.png";